<div class="overlay" *ngIf="isLoading | async"></div>

<div class="main-container">
    <!-- Header -->
    <app-header/>
    <!-- Main -->
    <div id="wrapper">
        <!-- <div class="nav">
            <app-navbar></app-navbar>
        </div> -->
        <div class="container">
            <router-outlet></router-outlet>
        </div>
    </div>
    <!-- Footer -->
    <app-footer fxLayout="row" fxLayoutAlign="center center"></app-footer>
</div>

<ngx-spinner size="medium" type="ball-clip-rotate-pulse"></ngx-spinner>